import { render, staticRenderFns } from "./Registries.vue?vue&type=template&id=3ef93bb7&scoped=true&"
import script from "./Registries.vue?vue&type=script&lang=js&"
export * from "./Registries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef93bb7",
  null
  
)

export default component.exports